<template>
  <div class="flex flex-wrap items-center gap-1.5 p-1
              bg-primary-50 dark:bg-dark-600
              border border-primary-100 dark:border-dark-500
              rounded-xl">
    <label
      v-for="option in options"
      :key="option.value"
      class="relative cursor-pointer"
    >
      <input
        type="radio"
        name="show"
        :value="option.value"
        :checked="option.value === 'all'"
        @change="filter"
        class="sr-only peer"
      />
      <span
        class="inline-flex items-center px-3 py-1.5 rounded-lg text-[12px] font-semibold
               whitespace-nowrap transition-all duration-200 select-none
               text-muted dark:text-muted-light
               peer-checked:bg-white dark:peer-checked:bg-dark-700
               peer-checked:text-primary-600 dark:peer-checked:text-primary-400
               peer-checked:shadow-card
               hover:text-dark-700 dark:hover:text-white"
      >
        {{ option.label }}
      </span>
    </label>
  </div>
</template>

<script>
export default {
  name: "RadioFilter",
  emits: ["filter"],

  setup(props, { emit }) {
    const options = [
      { value: "all",      label: "All" },
      { value: "today",    label: "Today" },
      { value: "upcoming", label: "Upcoming" },
      { value: "past",     label: "Past" },
    ];

    const filter = (e) => {
      emit("filter", e.target.value);
    };

    return { options, filter };
  },
};
</script>